export default __webpack_public_path__ + "static/media/greenBigDiary.5aacdeb6.png";